import React from 'react'

import { IconBase } from '../IconBase'
import { IconProps } from '../types'

export const Plus: React.FC<IconProps> = (props) => (
  <IconBase {...props}>
    <path
      d="M12 5V19M5 12H19"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </IconBase>
)
